import debugFactory from "debug";
import EventEmitter from "eventemitter3";

const events = Object.create( new EventEmitter() );

const debug = debugFactory( "teaming:common-storage:events" );

window.addEventListener( "storage", async event => {
	debug( event.key, event );
	events.emit( event.key, event );
	events.emit( "*", event );
} );

export default events;
